import React from "react";
import WhatsAppButton from "./Whatsupicon";
import ChatBot from "./ChatForm";
import FloatingContactButtons from "./Whatsupicon";


const FloatingSupport = () => {
  return (
    <div className="chat-floating-container">
      <FloatingContactButtons/>
      <ChatBot/>
    </div>
  );
};

export default FloatingSupport;
